import { render, staticRenderFns } from "./DeletePublishingScheduleDialog.vue?vue&type=template&id=0b994384&"
import script from "./DeletePublishingScheduleDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePublishingScheduleDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeletePublishingScheduleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports